module.exports = __webpack_public_path__ + "static/media/Buttons_Link button.42f35cbd.png";